import type { ReactNode } from 'react';

export interface TabItem {
  id: string;
  label: string;
  badge?: ReactNode;
  disabled?: boolean;
}

export interface TabsProps {
  items: TabItem[];
  activeId: string;
  onChange: (id: string) => void;
  className?: string;
}

const Tabs = ({ items, activeId, onChange, className }: TabsProps) => {
  return (
    <div className={['ui-tabs', className].filter(Boolean).join(' ')}>
      <div className="ui-tabs__list" role="tablist">
        {items.map((item) => {
          const isActive = item.id === activeId;
          const tabClass = ['ui-tabs__tab', isActive ? 'ui-tabs__tab--active' : ''].filter(Boolean).join(' ');
          return (
            <button
              key={item.id}
              type="button"
              className={tabClass}
              role="tab"
              aria-selected={isActive}
              onClick={() => onChange(item.id)}
              disabled={item.disabled}
            >
              {item.label}
              {item.badge}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Tabs;
